import { render } from "./PageSectionNavLinks.vue?vue&type=template&id=48bae4c4"
import script from "./PageSectionNavLinks.vue?vue&type=script&lang=js"
export * from "./PageSectionNavLinks.vue?vue&type=script&lang=js"

import "./PageSectionNavLinks.vue?vue&type=style&index=0&id=48bae4c4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__